const utm = function(){
    if(document.referrer !== undefined && document.referrer !== null && document.referrer?.length > 1){
        if(document.referrer.indexOf(window.location.protocol+"//"+window.location.host) != 0) {
            sessionStorage.setItem("referrer", document.referrer);
        }
    }
    var self = window.location.toString();
    var querystring = self.split("?");
    if (querystring.length > 1) {
        var pairs = querystring[1].split("&");
        for (let i in pairs) {
            var keyval = pairs[i].split("=");
            if (keyval[0] == 'utm_source' || keyval[0] == 'utm_medium' || keyval[0] == 'utm_campaign' || keyval[0] == 'utm_content' || keyval[0] == 'utm_term') {
                sessionStorage.setItem(keyval[0], decodeURIComponent(keyval[1]));
            }else{
                if(keyval[0] == 'gclid' && (sessionStorage.getItem("utm_source") === null || sessionStorage.getItem("utm_source")?.length < 1)){
                    sessionStorage.setItem("utm_source", "google");
                }
                if(keyval[0] == 'gclid' && (sessionStorage.getItem("utm_medium") === null || sessionStorage.getItem("utm_medium")?.length < 1)) {
                    sessionStorage.setItem("utm_medium", "cpc");
                }
                if(keyval[0] == 'ttclid' && (sessionStorage.getItem("utm_source") === null || sessionStorage.getItem("utm_source")?.length < 1)){
                    sessionStorage.setItem("utm_source", "tiktok");
                }
                if(keyval[0] == 'ttclid' && (sessionStorage.getItem("utm_medium") === null || sessionStorage.getItem("utm_medium")?.length < 1)) {
                    sessionStorage.setItem("utm_medium", "paid");
                }
            }
        }
    }
}
utm();
